import { Menu } from "@mantine/core";
import { IconChecklist } from "@tabler/icons-react";
import { useCallback } from "react";
import { useDispatch } from "src/redux/hooks";
import { setCheckListsModalProps } from "src/redux/slices/generatorSlice";

const CheckListsButton = () => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    dispatch(setCheckListsModalProps({ opened: true }));
  }, [dispatch]);

  return (
    <>
      <Menu.Item
        leftSection={<IconChecklist size={20} />}
        onClick={handleClick}>
        Checklists
      </Menu.Item>
    </>
  );
};

export default CheckListsButton;
